import {
  VehicleServices,
  VehicleServicesEditFormValues,
  VehicleServicesRow,
} from "./types";

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE SERVICES
-----------------------------------------------------------------------------------------*/

export const transformVehicleServices = (res: any): VehicleServices => {
  return {
    id: res.id,
    name: res.name,
    ratePerKm: res.ratePerKm,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE SERVICES SEARCH
-----------------------------------------------------------------------------------------*/

export const transformVehicleServicesRow = (res: any): VehicleServicesRow => {
  return {
    id: res.id,
    name: res.name,
    ratePerKm: res.ratePerKm,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE SERVICES CREATE
  -----------------------------------------------------------------------------------------*/

export const transformVehicleServicesOnCreate = (
  formValues: VehicleServicesEditFormValues
): any => ({
  name: formValues.name,
  ratePerKm: formValues.ratePerKm,
});

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE SERVICES EDIT
-----------------------------------------------------------------------------------------*/

export const transformVehicleServicesOnUpdate = (
  formValues: VehicleServicesEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
  ratePerKm: formValues.ratePerKm,
});
